<template>
  <v-layer ref="layer" :config="config">
    <v-image ref="dtext" :config="imgText" />
  </v-layer>
</template>

<script>
import Konva from 'konva'
import ImageText01 from '@/assets/event-ic-btn-text-01.png'
import ImageText02 from '@/assets/event-ic-btn-text-02.png'
import ImageText03 from '@/assets/event-ic-btn-text-03.png'
import ImageText04 from '@/assets/event-ic-btn-text-04.png'
import ImageText05 from '@/assets/event-ic-btn-text-05.png'
import ImageText06 from '@/assets/event-ic-btn-text-06.png'
import ImageText07 from '@/assets/event-ic-btn-text-07.png'
import ImageText08 from '@/assets/event-ic-btn-text-08.png'
import ImageText09 from '@/assets/event-ic-btn-text-09.png'
import ImageText10 from '@/assets/event-ic-btn-text-10.png'
import ImageText11 from '@/assets/event-ic-btn-text-11.png'

import { help } from './help'

export default {
  mixins: [help],
  data() {
    return {
      config: {
        visible: false
      },
      list: [
        ImageText01,
        ImageText02,
        ImageText03,
        ImageText04,
        ImageText05,
        ImageText06,
        ImageText07,
        ImageText08,
        ImageText09,
        ImageText10,
        ImageText11
      ],
      imgText: {
        image: null,
        x: this.transformWH(260),
        y: this.transformWH(660)
      },
      currentActive: 0
    }
  },
  async mounted() {
    await this.init()
    this.placeImage(this.list[1], 'imgText')
    await this.startAnimation()
  },
  methods: {
    async init() {
      for (const s of this.list) {
        await this.getImage(s)
      }
    },
    async startAnimation() {
      const dText = this.$refs.dtext.getNode()
      let counter = 0
      const dynamicTextAni = new Konva.Animation((frame) => {
        counter += 1
        if (counter % 10 === 0) {
          this.currentActive = (this.currentActive + 1) % this.list.length
          this.placeImage(this.list[this.currentActive], 'imgText')
        }
      }, dText.getLayer())

      dynamicTextAni.start()
    },
    async getCurrentText() {
      return await this.list[this.currentActive]
    },
    async hide() {
      this.config.visible = false
    },
    async show() {
      this.config.visible = true
    }
  }
}
</script>
